import {lazy} from 'react';

// project imports
import Loadable from "./RouteLoad/Loadable";
import {Navigate} from "react-router-dom";
import MinimalLayout from "../MinimalLayout";
import ForgotPassword from '../Authentication/authentication/forgotPassword';
import EmailVerification from '../Authentication/authentication/emailVerification';
import ForgotPasswordChange from '../Authentication/authentication/forgotPasswordChange';

const Login = Loadable(lazy(() => import('../Authentication/authentication/login')));
const SignUp = Loadable(lazy(() => import('../Authentication/authentication/register')));

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const UnauthorizedRoutes =
    [
        {
            path: '/',
            element: <MinimalLayout/>,
            children: [
                {
                    path: '/',
                    element: <Login/>
                },
                {
                    path: 'login',
                    element: <Login/>
                },
                {
                    path: 'signup',
                    element: <SignUp/>
                },
                {
                    path: 'forgotpassword',
                    element: <ForgotPassword/>
                },
                {
                    path: 'verify/:token',
                    element: <EmailVerification/>
                },
                {
                    path: 'change-password/:tocken',
                    element: <ForgotPasswordChange/>
                },
            ]
        },
        {
            path: "*",
            element: <Navigate to="/login"/>
        }
    ];

export default UnauthorizedRoutes;
